import React, { createContext, useCallback, useContext, } from "react";
import { useDispatch } from "react-redux";
import { useMainContext } from "../../../contexts";
import { showError } from "../../../util/message";
import { useTools } from "./useTools";
const ToolsContext = createContext(undefined);
export const useToolsContext = () => {
    const context = useContext(ToolsContext);
    if (!context) {
        throw new Error("useToolsContext must be used within ToolsProvider");
    }
    return context;
};
export const ToolsProvider = ({ children }) => {
    const { api } = useMainContext();
    const dispatch = useDispatch();
    const onShowError = useCallback((message, details, allowReport) => {
        showError(dispatch, message, details, { allowReport });
    }, [dispatch]);
    const value = useTools(onShowError, api);
    return (React.createElement(ToolsContext.Provider, { value: value }, children));
};
